export default  {
    props: {
        selectedDocuments: {

        }
    },

    methods: {
        border (index) {
            if (this.documents.length === 1) {
                return "top-bottom-border-radius";
            }

            if (index === 0) {
                return "top-border-radius";
            }

            if (index === this.documents.length - 1) {
                return "bottom-border-radius";
            }

            return "middle-border-radius";
        },

        onSelected (event) {
            this.$emit("selected", event);
        },

        isSelected (document) {
            if (!this.selectedDocuments) {
                return false;
            }

            return !!this.selectedDocuments.find(d => d.id === document.id);
        },
    }
}